export enum DividerData_LineStyle {
  /** SINGLE - Single Line */
  SINGLE = 'SINGLE',
  /** DOUBLE - Double Line */
  DOUBLE = 'DOUBLE',
  /** DASHED - Dashed Line */
  DASHED = 'DASHED',
  /** DOTTED - Dotted Line */
  DOTTED = 'DOTTED',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum DividerData_Width {
  /** LARGE - Large line */
  LARGE = 'LARGE',
  /** MEDIUM - Medium line */
  MEDIUM = 'MEDIUM',
  /** SMALL - Small line */
  SMALL = 'SMALL',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum DividerData_Alignment {
  /** CENTER - Center alignment */
  CENTER = 'CENTER',
  /** LEFT - Left alignment */
  LEFT = 'LEFT',
  /** RIGHT - Right alignment */
  RIGHT = 'RIGHT',
  UNRECOGNIZED = 'UNRECOGNIZED',
}